import React, { useEffect, useState } from "react";
import FilterConfirmation from "../FilterConfirmationComponent/FilterConfirmation";
import "./LoaderComponent.css";
export default function LoaderComponent(props) {
  const {time,onClickSubmit,tag,code,filterToggle} = props;
  const [count, setCount] = useState(time);
  const [showLoader, setShowLoader] = useState(true);
console.log(time,"in props of Loader Component")
 
  const decrementCOunt=()=>{
    const tempCount = count -1;
    setCount(tempCount);
  }
  useEffect(() => {
    const timer = setTimeout(() => {
     decrementCOunt();
     
    }, 1000);
    
  if(count ===-1){

    clearTimeout(timer);
    setShowLoader(false);
    filterToggle(false);
    onClickSubmit(code,null,tag);
  }
  });
 

  return (
    <div className="loaderContainer">
      <p>{count}</p>

      {showLoader ? (
        <div id="loader-wrapper">
          <div class="loader"></div>
        </div>
      ) : null}
    </div>
  );
}
